<template>
  <div>
    <el-dropdown trigger="hover" @visible-change="handleVisible">
      <div class="avatar-content nav-bar-item ml12">
        <img class="icon icon-w" :src="imgSrc16" alt="" />
        <span class="user-name">{{ userInfo.userName }}</span>
      </div>
      <el-dropdown-menu
        slot="dropdown"
        class="user-dropdown-content"
        @mouseenter="handleDropdownMouseEnter"
        @mouseleave="handleDropdownMouseLeave"
      >
        <QSCard :btnList="btnList">
          <template #titleBox>
            <img class="icon icon-n" :src="imgSrc40" alt="" />
            <div class="user-box">
              <span class="user-name">{{ userInfo.userName }}</span>
              <div class="user-role">
                <QS-clamp-lines
                  :lines="1"
                  :text="userInfo.roleName"
                  :showPop="false"
                  :isAllowExtra="true"
                />
              </div>
            </div>
          </template>
          <template #infoBox>
            <div class="item" v-if="userInfo.userAccount">
              <div class="title">
                <i class="icon QS-icon-account" />
                <span class="label">{{ userInfo.userAccount }}</span>
              </div>
            </div>
            <div class="item" v-if="userInfo.userMobile">
              <div class="title">
                <i class="icon QS-icon-phone" />
                <span class="label">{{ userInfo.userMobile }}</span>
              </div>
            </div>
            <div class="item other-item" @click="handleModifyPwd" v-if="loginWithPassword">
              <div class="title">
                <i class="icon QS-icon-lock" />
                <span class="label">修改密码</span>
              </div>
              <i class="el-icon-arrow-right"></i>
            </div>
            <div
              class="item other-item"
              v-if="wechatLoginBinding"
              @click="unbindWechatLogin"
            >
              <div class="title">
                <img
                  class="icon wechat-bind-avatar"
                  :src="wechatLoginBinding.avatar"
                  alt=""
                />
                <span class="label">解绑微信登录（{{ wechatLoginBinding.nickname }}）</span>
              </div>
              <i class="el-icon-arrow-right"></i>
            </div>
            <!-- 未绑微信登录：常驻绑定入口，与上方解绑入口互斥 -->
            <div
              class="item other-item"
              v-else
              @click="openWechatBind"
            >
              <div class="title">
                <svg-icon icon-class="link" class="icon" />
                <span class="label">绑定微信登录</span>
              </div>
              <i class="el-icon-arrow-right"></i>
            </div>
            <div
              class="item other-item"
              v-if="wechatNotifyBound"
              @click="unbindWechatNotify"
            >
              <div class="title">
                <svg-icon icon-class="ic-unbinding" class="icon" />
                <span class="label">解绑微信通知</span>
              </div>
              <i class="el-icon-arrow-right"></i>
            </div>
          </template>
          <template #customBox>
            <div class="sys-version" v-if="sysVersion">
              系统版本号{{ sysVersion }}
            </div>
          </template>
        </QSCard>
      </el-dropdown-menu>
    </el-dropdown>
    <modifyPwd
      :modifyPwdVisible="modifyPwdVisible"
      @updateVisible="handlerUpdateVisible"
    >
    </modifyPwd>
    <wx-bind-login-self-dialog
      ref="wxBindLoginDialog"
      @success="onWechatBindSuccess"
    />
  </div>
</template>
<script>
import QSCard from '@/components/QSCard/index.vue'
import { mapGetters } from 'vuex'
import avatar16 from '../assets/avatar-16.png'
import avatar40 from '../assets/avatar-40.png'
import modifyPwd from './modifyPwd.vue'
import WxBindLoginSelfDialog from './WxBindLoginSelfDialog.vue'
import { getCloudConfig } from '@/api/login'
import { WECHAT_LOGIN_BIND_KEY } from '@/utils/wechatBinding'

export default {
  components: {
    QSCard,
    modifyPwd,
    WxBindLoginSelfDialog,
  },
  computed: {
    ...mapGetters(['userInfo']),
    avatar() {
      const arr = this.getURL({
        data: this.userInfo.avatar,
        needName: true,
      })
      if (!Array.isArray(arr) || arr.length === 0) {
        return null
      }
      return arr[0].url
    },
    imgSrc16() {
      return this.avatar || this.avatar16
    },
    imgSrc40() {
      return this.avatar || this.avatar40
    },
    // 微信扫码登录绑定：匹配 bindings 的 WeChatWebsiteApp，取 { avatar, nickname }
    // （value 还可能带一个 optional 的唯一标识字符串，业务未使用，仅登记）
    wechatLoginBinding() {
      // 本次会话内已自助解绑：立即隐藏（真实数据由 GetUserInfo 刷新）
      if (this.wechatLoginUnbound) return null
      const val = this.findBindingValue(WECHAT_LOGIN_BIND_KEY)
      // 未绑定（key 不存在）返回 null；已绑定但服务端未回头像昵称时用默认兜底
      if (val === undefined) return null
      const info = val && typeof val === 'object' ? val : {}
      return {
        avatar: info.avatar || this.avatar40,
        nickname: info.nickname || '微信用户',
      }
    },
    // 微信通知绑定：精确匹配 WeChatOfficialAccount key 是否存在
    wechatNotifyBound() {
      return this.hasBindingKey('WeChatOfficialAccount')
    },
  },
  data() {
    return {
      avatar16,
      avatar40,
      isShow: false,
      modifyPwdVisible: false,
      sysVersion: '',
      btnList: [
        {
          type: 'confirm',
          text: '退出登录',
          event: this.logout,
          style: {
            width: '100%',
          },
        },
      ],
      loginWithPassword: false, // 是否可以修改密码
      wechatLoginUnbound: false, // 本会话内已解绑微信登录，用于立即隐藏入口
    }
  },
  created() {
    this.getCloudConfig()
  },
  methods: {
    handleVisible(flag) {
      // 防抖处理，防止闪烁
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer)
        this.hoverTimer = null
      }

      if (flag) {
        // 立即显示，无延迟
        this.isShow = true
      } else {
        // 延迟隐藏，防止鼠标快速移动导致的闪烁
        this.hoverTimer = setTimeout(() => {
          this.isShow = false
          this.hoverTimer = null
        }, 150)
      }
    },
    handleModifyPwd() {
      this.modifyPwdVisible = true
    },
    handleDropdownMouseEnter() {
      // 鼠标进入下拉菜单时，取消隐藏定时器
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer)
        this.hoverTimer = null
      }
    },

    handleDropdownMouseLeave() {
      // 鼠标离开下拉菜单时，延迟隐藏
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer)
      }
      this.hoverTimer = setTimeout(() => {
        this.isShow = false
        this.hoverTimer = null
      }, 150)
    },
    handlerUpdateVisible(state) {
      this.modifyPwdVisible = state
    },
    // 从 userInfo.bindings（[{ 渠道key: valueObj }]）中取指定渠道的绑定值
    findBindingValue(key) {
      const list = this.userInfo.bindings || []
      const hit = list.find((b) => b && Object.prototype.hasOwnProperty.call(b, key))
      return hit ? hit[key] : undefined
    },
    hasBindingKey(key) {
      return this.findBindingValue(key) !== undefined
    },
    // 解绑微信「通知」（/wechat/unbind）
    unbindWechatNotify() {
      this.$confirm('确定要解除微信通知绑定么，你可以随时重新绑定。', '解绑微信通知', {
        confirmButtonText: '确定解绑',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // UnbindWechat 内部已 dispatch('GetUserInfo') 刷新 bindings，入口随之消失
        return this.$store.dispatch('UnbindWechat')
      }).then(() => {
        this.$message.success('解绑成功')
      }).catch(() => {
        // do nothing
      })
    },
    // 打开自助绑定微信登录弹窗
    openWechatBind() {
      this.$refs.wxBindLoginDialog.open()
    },
    // 绑定成功：清除会话解绑标志并刷新 bindings，随后展示头像昵称
    onWechatBindSuccess() {
      this.wechatLoginUnbound = false
      this.$store.dispatch('GetUserInfo')
    },
    // 解绑微信「登录」（本人：不传 userId，后端按 token 认身份）
    unbindWechatLogin() {
      this.$confirm('解绑后本车务账号将无法通过微信扫码登录。您可以随时重新绑定。', '解绑微信登录', {
        confirmButtonText: '确定解绑',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // UnbindWechatLogin 内部已 dispatch('GetUserInfo') 刷新 bindings
        return this.$store.dispatch('UnbindWechatLogin')
      }).then(() => {
        this.$message.success('解绑成功')
        // 会话内立即隐藏入口，GetUserInfo 刷新 bindings 前先靠此标志隐藏
        this.wechatLoginUnbound = true
      }).catch(() => {
        // do nothing
      })
    },
    logout() {
      this.$confirm('确定退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
          setTimeout(() => {
            sessionStorage.removeItem('oldStartIndex')
          }, 10)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退出登录',
          })
        })
    },
    getCloudConfig() {
      getCloudConfig({
        configKey: 'loginConfig',
      }).then(({ data }) => {
        this.loginWithPassword = data.loginWithPassword
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.avatar-content {
  padding: 12px 16px;
  margin-left: 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
  border-radius: 6px;
  user-select: none;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  .icon {
    font-size: 16px;
    margin-right: 10px;
  }
}
.user-box {
  width: 100%;
  overflow: hidden;
}
.user-role {
  width: 100%;
  overflow: hidden;
}

.user-dropdown-content {
  width: 260px;
  padding: 0px;
  border-radius: 8px;
  margin-top: 0;

  .title-box {
    display: flex;
    align-items: center;

    .icon {
      font-size: 40px;
      margin-right: 6px;
    }
  }

  .item {
    padding: 4px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      display: flex;
      align-items: center;
      .icon {
        display: inline-block;
        margin-right: 5px;
        flex-shrink: 0;
      }

      .label {
        color: rgba(0, 0, 0, 0.7);
        word-break: break-all;
        white-space: normal;
      }
    }
  }

  .other-item {
    cursor: pointer;
  }

  .sys-version {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.3);
    text-align: center;
  }
}
.icon-w {
  width: 16px;
  height: 16px;
  border-radius: 50%;
}
.icon-n {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.wechat-bind-avatar {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  object-fit: cover;
}
</style>
